// extracted by mini-css-extract-plugin
export default {"login_bg":"LoginPage_login_bg__lZWpk"};